import axios from "axios";

export default {
	namespaced: true,
	state: {
		myPlan: null,
		basicPlan: null,
		publicPlans: [],
		privatePlans: [],
		addons: [],
		planPassword: null,
	},
	mutations: {
		setMyPlan(state, payload) {
			state.myPlan = payload;
		},
		setBasicPlan(state, payload) {
			state.basicPlan = payload;
		},
		setPublicPlans(state, payload) {
			state.publicPlans = payload;
		},
		setPrivatePlans(state, payload) {
			state.privatePlans = payload;
		},
		setAddons(state, payload) {
			state.addons = payload;
		},
		setPlanPassword(state, payload) {
			state.planPassword = payload;
		},
	},
	getters: {
		getMyPlan: function (state) {
			return state.myPlan;
		},
		getBasicPlan: function (state) {
			return state.basicPlan;
		},
		getPublicPlans: function (state) {
			let publicPlans = [...state.publicPlans];
			if (state.basicPlan) {
				publicPlans.push(state.basicPlan);
			}
			return publicPlans;
		},
		getPrivatePlans: function (state) {
			return state.privatePlans;
		},
		getPublicPlanById(state) {
			return ({id}) => {
				if (state.publicPlans.length === 0) {
					return null;
				}

				return state.publicPlans.find((item) => {
					return item.id === id;
				});
			};
		},
		getPublicPlanByGroup(state) {
			return ({group}) => {
				if (state.publicPlans.length === 0) {
					return [];
				}

				return state.publicPlans.filter((item) => {
					return item.plan_group === group;
				});
			};
		},
		getAddons: function (state) {
			return state.addons;
		},
		getPlanPassword: function (state) {
			return state.planPassword;
		},
		getAllInclusivePlan: function (state) {
			return state.publicPlans.find((plan) => {
				return plan.plan_group.toLowerCase() === 'merchant' && plan.nickname.toLowerCase() === 'all inclusive';
			});
		},
    initRequestPayload(state, getters) {
      return {
				timestamp: Math.floor(Date.now() / 1000),
        plan_id: getters.getAllInclusivePlan?.id,
        checkout_session_mode: 'CUSTOM',
        currency: (getters.getMyPlan?.currency_code || 'CAD').toUpperCase(),
        period: getters.getAllInclusivePlan?.period || 'YEARLY',
        addons: getters.getMyPlan?.addons.map(({ id, quantity }) => ({ id, quantity })),
				flow: getters.getAllInclusivePlan?.id === getters.getMyPlan?.plan.id ? 'update' : 'create',
      };
    },
	},
	actions: {
		//plan
		async getPlan(ctx, {id} = {}) {
			return axios.get(`/api/v1/subscription/plan/${id}`).then((res) => {
				if (res.status === 200) {
					const formattedPrices = {};
					res.data.prices.forEach((price) => {
						const key = price.currency_code;

						if (!formattedPrices[key]) {
							formattedPrices[key] = {
								currency_code: price.currency_code,
								active: price.active,
								YEARLY: {},
								MONTHLY: {},
							};
						}

						formattedPrices[key][price.price_duration] = {
							price_id: price.price_id,
							price_in_cents: price.price_in_cents,
						};
					});
					res.data.prices = Object.values(formattedPrices);
				}
				return res;
			});
		},
		async getPublicPlans(ctx, {page = 0, size = 100}) {
			return axios
				.post(`/api/v1/subscription/plan/search?start=${page}&size=${size}`, {
					is_active: true,
					is_public: true,
				})
				.then(async (res) => {
					if (res.status === 200) {
						if (res.data?.content.length > 0) {
							let publicPlans = res.data.content.sort((a, b) => a.storage.storage_limit - b.storage.storage_limit);
							// Fetch prices for each plan
							await Promise.all(
								publicPlans.map(async (plan) => {
									let priceRes = await ctx.dispatch("searchPlanPrice", {
										planId: plan.id,
										req: {
											// currency_code: currency,
										},
										page: 0,
										size: 100,
									});
									if (priceRes.status === 200) {
										const rawPrices = priceRes.data.content;
										const formattedPrices = {};

										rawPrices.forEach((price) => {
											const key = price.currency_code;

											if (!formattedPrices[key]) {
												formattedPrices[key] = {
													currency_code: price.currency_code,
													active: price.active,
													YEARLY: {},
													MONTHLY: {},
												};
											}

											formattedPrices[key][price.price_duration] = {
												price_id: price.price_id,
												price_in_cents: price.price_in_cents,
											};
										});
										plan.prices = Object.values(formattedPrices);
										// plan.prices = priceRes.data.content;
									} else {
										plan.prices = [];
									}
								})
							);
							ctx.commit("setPublicPlans", publicPlans);
							return publicPlans;
						}
					}
				})
				.catch((err) => {
					console.log("Fail to get public plans:", err);
					return [];
				});
		},
		// async getPrivatePlans(ctx, {page = 0, size = 100}) {
		// 	return axios
		// 		.post(`/api/v1/subscription/plan/search?start=${page}&size=${size}`, {
		// 			is_active: true,
		// 			is_public: false,
		// 		})
		// 		.then(async (res) => {
		// 			if (res.status === 200) {
		// 				if (res.data?.content.length > 0) {
		// 					let privatePlans = res.data.content.sort((a, b) => a.storage.storage_limit - b.storage.storage_limit);
		// 					// Fetch prices for each plan
		// 					await Promise.all(
		// 						privatePlans.map(async (plan) => {
		// 							let priceRes = await ctx.dispatch("searchPlanPrice", {
		// 								planId: plan.id,
		// 								req: {
		// 									// currency_code: currency,
		// 								},
		// 								page: 0,
		// 								size: 100,
		// 							});
		// 							if (priceRes.status === 200) {
		// 								const rawPrices = priceRes.data.content;
		// 								const formattedPrices = {};

		// 								rawPrices.forEach((price) => {
		// 									const key = price.currency_code;

		// 									if (!formattedPrices[key]) {
		// 										formattedPrices[key] = {
		// 											currency_code: price.currency_code,
		// 											active: price.active,
		// 											YEARLY: {},
		// 											MONTHLY: {},
		// 										};
		// 									}

		// 									formattedPrices[key][price.price_duration] = {
		// 										price_id: price.price_id,
		// 										price_in_cents: price.price_in_cents,
		// 									};
		// 								});
		// 								plan.prices = Object.values(formattedPrices);
		// 								// plan.prices = priceRes.data.content;
		// 							} else {
		// 								plan.prices = [];
		// 							}
		// 						})
		// 					);
		// 					ctx.commit("setPrivatePlans", privatePlans);
		// 					return privatePlans;
		// 				}
		// 			}
		// 		})
		// 		.catch((err) => {
		// 			console.log("Fail to get private plans:", err);
		// 			return [];
		// 		});
		// },
		async getBasicPlans(ctx, {page = 0, size = 100}) {
			return axios
				.post(`/api/v1/subscription/plan/search?start=${page}&size=${size}`, {
					is_active: true,
					is_public: true,
					is_default: true,
				})
				.then(async (res) => {
					if (res.status === 200) {
						if (res.data?.content.length > 0) {
							let plan = res.data.content[0];
							// Fetch prices for each plan
							ctx.commit("setBasicPlan", plan);
							return plan;
						}
					}
				})
				.catch((err) => {
					console.log("Fail to get private plans:", err);
					ctx.commit("setBasicPlan", null);
					return null;
				});
		},
		async getPlans(ctx) {
			ctx.dispatch("getPublicPlans", {});
			ctx.dispatch("getBasicPlans", {});
			// ctx.dispatch("getPrivatePlans", {});
		},
		async getRecommended() {
			return axios.post(`/api/v1/subscription/account/me/subscription/recommended`);
		},
		async searchPlans(ctx, {req, page = 0, size = 15}) {
			return axios.post(`/api/v1/subscription/plan/search?start=${page}&size=${size}`, req);
		},
		async postPlan(ctx, {plan}) {
			return axios.post(`/api/v1/subscription/plan`, plan);
		},
		async updatePlan(ctx, {plan}) {
			return axios.put(`/api/v1/subscription/plan/${plan.id}`, plan);
		},
		async deletePlan(ctx, {planId}) {
			return axios.delete(`/api/v1/subscription/plan/${planId}`);
		},
		//plan price
		async createPlanPrice(ctx, {planId, planPrice}) {
			return axios.post(`/api/v1/subscription/plan/${planId}/price`, planPrice);
		},
		async deletePlanPrice(ctx, {planId, priceId}) {
			return axios.post(`/api/v1/subscription/plan/${planId}/price/${priceId}`);
		},
		async searchPlanPrice(ctx, {planId, req, page = 0, size = 15}) {
			return axios.post(`/api/v1/subscription/plan/${planId}/price/search?start=${page}&size=${size}`, req);
		},
		//addon
		async getAdd(ctx, {id}) {
			return axios.get(`/api/v1/subscription/addon/${id}`);
		},
		async getAddons(ctx, {req, page = 0, size = 100}) {
			return axios
				.post(`/api/v1/subscription/addon/search?start=${page}&size=${size}`, req)
				.then(async (res) => {
					if (res.status === 200) {
						if (res.data?.content.length > 0) {
							let addons = res.data.content;

							// Fetch prices for each plan
							await Promise.all(
								addons.map(async (addon) => {
									let priceRes = await ctx.dispatch("searchAddonPrice", {
										addonId: addon.id,
										req: {
											// currency_code: currency,
										},
										page: 0,
										size: 100,
									});
									if (priceRes.status === 200) {
										const rawPrices = priceRes.data.content;
										const formattedPrices = {};

										rawPrices.forEach((price) => {
											const key = price.currency_code;

											if (!formattedPrices[key]) {
												formattedPrices[key] = {
													currency_code: price.currency_code,
													active: price.active,
													YEARLY: {},
													MONTHLY: {},
												};
											}

											formattedPrices[key][price.price_duration] = {
												price_id: price.price_id,
												price_in_cents: price.price_in_cents,
												pricing_mode: price.pricing_mode,
												tiers: price.tiers,
											};
										});
										addon.prices = Object.values(formattedPrices);
									} else {
										addon.prices = [];
									}
								})
							);
							ctx.commit("setAddons", addons);
							return addons;
						}
					}
				})
				.catch((err) => {
					console.log("Fail to get addons:", err);
					return [];
				});
		},
		async createAddon(ctx, {addon}) {
			return axios.post(`/api/v1/subscription/addon`, addon);
		},
		async updateAddon(ctx, {addon}) {
			return axios.put(`/api/v1/subscription/addon/${addon.id}`, addon);
		},
		async searchAddons(ctx, {req, page = 0, size = 15}) {
			return axios.post(`/api/v1/subscription/addon/search?start=${page}&size=${size}`, req);
		},
		//addon price
		async createAddonPrice(ctx, {addonId, addonPrice}) {
			return axios.post(`/api/v1/subscription/addon/${addonId}/price`, addonPrice);
		},
		async deleteAddonPrice(ctx, {addonId, priceId}) {
			return axios.delete(`/api/v1/subscription/addon/${addonId}/price/${priceId}`);
		},
		async searchAddonPrice(ctx, {addonId, req, page = 0, size = 15}) {
			return axios.post(`/api/v1/subscription/addon/${addonId}/price/search?start=${page}&size=${size}`, req);
		},
		//subscription
		// for admin
		async getAccountPlan(ctx, {id}) {
			return axios.get(`/api/v1/subscription/account/${id}`);
		},
		// for users
		async getSelfAccountPlan(ctx) {
			return axios
				.get(`/api/v1/subscription/account/me`)
				.then((res) => {
					if (res.status === 200) {
						ctx.commit("setMyPlan", res.data);
					}
					return res;
				})
				.catch((err) => {
					ctx.commit("setMyPlan", null);
					return err;
				});
		},
		async createSubscription(ctx, {request}) {
			return axios.post(`/api/v1/subscription/account/me/subscribe`, request);
		},
		async updateSubscription(ctx, {request}) {
			return axios.post(`/api/v1/subscription/account/me/subscription/update`, request);
		},
		async updateSubscriptionPreview(ctx, {request}) {
			return await axios.post(`/api/v1/subscription/account/me/subscription/update/preview`, request);
		},
		async unsubscribe(ctx, {request}) {
			return await axios.post(`/api/v1/subscription/account/me/subscription/unsubscribe`, request);
		},
		async cancelUnsubscribe() {
			return await axios.post(`/api/v1/subscription/account/me/subscription/unsubscribe/cancel`);
		},
		async getSessionStatus(ctx, {sessionId}) {
			return axios.post(`/api/v1/subscription/account/me/subscribe/${sessionId}/status`);
		},
		async getCustomerSession() {
			return axios
				.get(`/api/v1/subscription/account/me/session`)
				.then((res) => {
					return res;
				})
				.catch((err) => {
					console.log("Fail to getCustomerSession ", err);
					return err;
				});
		},
		async resynchronizeAccount(ctx, {accountId}) {
			return axios.get(`/api/v1/subscription/account/${accountId}/synchronize`);
		},
	},
};
